module.exports = __webpack_public_path__ + "static/media/customers.5ee3d750.svg";